<template>
  <v-app>
    <v-app-bar
      color="primary"
      :clipped-left="this.$vuetify.breakpoint.smAndUp"
      elevate-on-scroll
      app
      dark
      absolute
    >
      <v-app-bar-nav-icon @click="toggleDrawer"/>

      <v-toolbar-title>{{$appMng.title}}</v-toolbar-title>

      <v-spacer/>      

      <subscription-button/>

      <help-button/>

      <news/>

      <!-- <shopping-cart-button/> -->

      <v-menu
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            id="my-account-btn"
            color="accent"
            v-on="on"
            fab
            elevation="1"
            small
          >
            <img class="user-img" v-if="profilePicPresignedUrl" :src="profilePicPresignedUrl" />
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            to="/app/my-account"
          >
            <v-list-item-title>Minha conta</v-list-item-title>
          </v-list-item>
          <v-list-item
            id="logout-btn"
            @click="logout"
          >
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      id="layout-nav-drawer"
      :mini-variant="miniVariant && $vuetify.breakpoint.mdAndUp"
      :clipped="$vuetify.breakpoint.mdAndUp"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :temporary="drawer && $vuetify.breakpoint.xsOnly"
      height="100%"
      disable-route-watcher
      absolute
      app
    >
      <v-divider/>
      <v-list
        id="layout-nav-drawer-list"
        nav
        rounded
      >
        <v-tooltip
          right
          v-for="item in menuList"
          :key="item.name"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              @click="item.onClick"
              :id="'nav-drawer-list-item-' + item.normalized_name"
              link
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon
                  color="primary"
                >
                  {{item.icon}}
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>

      <div v-if="$store.state.user.userData.blAllowAdmin">
        <v-row align="center">
          <v-divider>
            </v-divider>
              <span class="grey--text darken-3">Exclusivos Admin</span>
            <v-divider>
          </v-divider>
        </v-row>

          <v-tooltip
            right
            v-for="item in menuListAdmin"
            :key="item.name"
          >
            <template v-slot:activator="{ on }">
              <v-list-item
                @click="item.onClick"
                :id="'nav-drawer-list-item-' + item.normalized_name"
                link
                v-on="on"
              >
                <v-list-item-icon>
                  <v-icon
                    color="primary"
                  >
                    {{item.icon}}
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-container
        v-if="isLoadingPage"
        fluid
        class="fill-height"
      >
        <loading-screen/>
      </v-container>
      <dialog-news></dialog-news>       
      <router-view v-show="!isLoadingPage"/>
    </v-content>
  </v-app>
</template>

<script>
  import { MenuList, MenuListAdmin } from "../helpers/menu"
  import LoadingScreen from "./Helpers/LoadingScreen"
  import SubscriptionButton from "./Helpers/Buttons/SubscriptionButton"
  // import ShoppingCartButton from "./Helpers/Buttons/ShoppingCartButton"
  import HelpButton from "./Helpers/Buttons/HelpButton"
  import { filter } from "lodash/collection"
  // import { UserData } from "../api/api-auth"
  // import { isEqual } from "lodash/lang"
  // import { FLOWS_IDS } from '../helpers/conpass/constants'
  import News from "./Helpers/News"
  import DialogNews from './Helpers/Dialogs/DialogNews'
  import {PicUploaderEventBus} from "../helpers/upload/events"
  import {PROJECT_URL} from "../globals"
  // import * as Sentry from "@sentry/vue";

  export default {
    name: "Layout",
    components: {
      // ShoppingCartButton,
      SubscriptionButton,
      HelpButton,
      LoadingScreen,
      News,
      DialogNews
    },
    data() {
      return {
        profilePicPresignedUrl: "",
        drawer: false,
        miniVariant: false,
        userMenu: false,
        conpassRetryCount: 0
      }
    },
    methods: {
      toggleDrawer() {
        if (this.$vuetify.breakpoint.mdAndUp)
          this.miniVariant = !this.miniVariant
        else
          this.drawer = !this.drawer
      },
      logout() {
        // try {
        //   Sentry.configureScope(scope => scope.setUser(null));
        // } catch (e) {
        //   console.log("Not clear Sentry user session")
        // }
        this.$apiAuth.logout()
          .then(() => {
            this.$router.push("/login")
          })
      },
      // initConpass(userData, userPlan, isSubscriber, hasActivePlan) {
      //   setTimeout(() => {
      //     if (window.Conpass)
      //       window.Conpass.init({
      //         name: userData.strName,
      //         email: userData.strEmail,
      //         custom_fields: {
      //           plano: userPlan,
      //           plano_ativo: hasActivePlan,
      //           assinante: isSubscriber
      //         }
      //       })
      //     else if (this.conpassRetryCount < 100) this.initConpass(userData, userPlan, isSubscriber, hasActivePlan)
      //     else return
      //     this.conpassRetryCount += 1
      //   }, 100)
      // },
      async getUserImg() {
        const authToken = this.$apiAuth.getAuthToken();
        const userId = this.$store.state.user.userData.idUserAccount;
        const rawResponse = await fetch(`${PROJECT_URL}/projects/generate-picture-presigned-url/?userid=${userId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`
          },
        });
        const content = await rawResponse.json();
        if (content.presigned_url) {
          this.profilePicPresignedUrl = content.presigned_url;
        }
      },
      eraseProfilePic() {
        this.profilePicPresignedUrl = null;
      }
    },
    computed: {
      isLoadingPage() {
        return this.$appMng.isLoadingPage
      },
      menuList() {
        if (this.$vuetify.breakpoint.mdAndUp)
          return MenuList

        return filter(MenuList, menu => menu["mobile"])
      },
      menuListAdmin() {
        if (this.$vuetify.breakpoint.mdAndUp)
          return MenuListAdmin

        return filter(MenuListAdmin, menu => menu["mobile"])
      },
      // conpassFlow() {
      //   return FLOWS_IDS.HELP_BTN_PROCESSING_LIST
      // }
    },
    created() {
      // if (window.Conpass.user) return
      this.$apiAuth.whoami()
        .then(() => {
          // const userData = UserData.fromObject(response.data)
          // this.$subsMng.getSubscription(this.$apiAuth.getAuthToken())
          //   .then(() => {
          //     // let isSubscriber = () => {
          //     //   if (this.$subsMng.isSubscriptionEmpty)
          //     //     return false
          //     //   else
          //     //     return !isEqual(this.$subsMng.subscriptionPlan["ab_subscription_plan"], "PRO_PLAN_TRIAL")
          //     // }
          //     // let hasActivePlan = (this.$subsMng.isSubscriptionEmpty ? false : this.$subsMng.subscription["bl_activated"])
          //     // let userPlan = this.$subsMng.subscriptionPlan["ab_subscription_plan"]
          //     // this.initConpass(userData, userPlan, isSubscriber(), hasActivePlan)
          //   })
        })
        .catch(error => {
          console.log(error)
        })
    },
    mounted() {
      PicUploaderEventBus.$on("profile-pic-changed", this.getUserImg)
      PicUploaderEventBus.$on("profile-pic-deleted", this.eraseProfilePic)
      this.getUserImg();
    }
  }
</script>

<style scoped lang="scss">
.user-img {
  height: 40px;
  width: 40px;
  border-radius: 50%;
}
</style>
